import { Injectable } from '@angular/core';

import { Role } from '@pp/core/entities';

@Injectable({
  providedIn: 'root',
})
export class DictionariesService {
  readonly #statuses = new Map([
    ['Active', 'status.card.active'],
    ['Invited', 'status.card.invited'],
    ['Blocked', 'status.card.blocked'],
    ['ActiveCard', 'status.card.activeCard'],
    ['BlockedCard', 'status.card.blockedCard'],
    ['ClosedCard', 'status.card.closedCard'],
    ['InProgress', 'status.card.inProgress'],
    ['Failed', 'status.card.failed'],
  ]);

  roles = new Map<Role, string>([
    [Role.Admin, 'dictionary.role.admin'],
    [Role.SuperAdmin, 'dictionary.role.superAdmin'],
    [Role.Buyer, 'dictionary.role.buyer'],
    [Role.Supervisor, 'dictionary.role.supervisor'],
  ]);

  getStatus(status: string): string | undefined {
    return this.#statuses.get(status);
  }
}
